var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionCategoryList", {
        attrs: {
          xs12: "",
          categoryList: _vm.categoryList,
          shouldShowSearch: true,
          toolbarActions: [
            {
              text: "Category",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewCategoryClicked",
            },
          ],
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewCategoryClicked: function ($event) {
            _vm.showDialogFormCategoryAdd = true
          },
          onEditCategoryClicked: (val) => [
            (_vm.categoryToEdit = val.categoryToEdit),
            (_vm.showDialogFormCategoryEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormCategoryAdd", {
        attrs: {
          showDialog: _vm.showDialogFormCategoryAdd,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormCategoryAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormCategoryAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormCategoryEdit", {
        attrs: {
          showDialog: _vm.showDialogFormCategoryEdit,
          categoryToEdit: _vm.categoryToEdit,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormCategoryEdit = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormCategoryEditSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }